import { render, staticRenderFns } from "./billList.vue?vue&type=template&id=0fb87ac0&scoped=true"
import script from "./billList.vue?vue&type=script&lang=js"
export * from "./billList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb87ac0",
  null
  
)

export default component.exports